@import (reference) '../../../../../constants/spacing.module.less';

.shipFromList {
  margin-top: @space-24;
  margin-bottom: @space-24;
}

.radioList {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.radioItem {
  display: block;
}

.radioCheckItem {
  padding: 0 0 @space-16;

  label {
    align-items: initial;
  }
}

.shipFromDetails {
  display: flex;
  flex-direction: column;
}

.address {
  display: flex;
  margin-top: @space-8;

  p {
    margin-right: @space-4;
    &:not(:last-child):after {
      content: ',';
    }
  }
}

.returnLocationName {
  font-weight: 500;
}

.returnLocationBanner {
  margin-top: @space-24;
}

.returnLocationDescription {
  display: block;
  line-height: @space-24;
  font-size: 14px;
  margin: @space-8 0 @space-24 0;
}

.noShipstationLocations {
  line-height: 25px;
  font-size: 14px;
}
